module.exports = __webpack_public_path__ + "img/bj-2.4e21cb93.jpg";